import HTTPClient from "./http-client";
import HTTPClientPublic from "./http-client_public";
// import HTTPClientCache from "./http-client_cache";

// Override `maxAge` and cache URLs with query parameters
// const options = {
//   cache: {
//       maxAge: 1 * 60 * 60 * 1000, // set cache time to 1 hour (instead 15 minutes)
//       exclude: { query: false } // cache requests with query parameters
//   }
// }

class UserService {
  async getAll() {
    // const httpClient = new HTTPClientCache();
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();

    // return api.get(`/users`, options);
    return api.get(`/users`);
  }

  async getUser(id) {
    // const httpClient = new HTTPClientCache();
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();

    // return api.get(`/user/${id}`, options);
    return api.get(`/user/${id}`);
  }

  async getCurrentUserinfo() {
    // const httpClient = new HTTPClientCache();
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();

    // return api.get("/current_user", options);
    return api.get("/current_user");
  }

  async putUser(id, user) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    const res = await api.put(`/user/${id}`, user)
      .catch((error) => {
        switch (error.response.status) {
          case 500:
            throw {
              title: "Serviço indisponível",
              message: "Não foi possível editar o usuário, tente novamente.",
            };
          default:
            throw {
              title: "Serviço indisponível",
              message: error.response.data.message,
            };
        }
      });

    return res;
  }

  async postUser(user) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();

    const res = await api.post("user", user).catch(function (error) {
      switch (error.response.status) {
        case 400:

          if (error.response.data.message == "Email already exists!") {
            throw {
              title: "O E-mail já existe",
              message: "O email informado já está cadastrado no AlertaDis.",
            };
          }
          if (error.response.data.message == "Originalid already exists!") {
            throw {
              title: "A matrícula já existe",
              message: "A matrícula informado já está cadastrado no AlertaDis.",
            };
          }

          throw {
            message: error.response.data.message,
          };

        case 500:
          throw {
            title: "Serviço indisponível",
            message: "Não foi possível adicionar o usuário, tente novamente.",
          };
        default:
          throw {
            title: "Serviço indisponível",
            message: error.response.data.message,
          };
      }
    });

    return res;
  }

  async updatePassword(newPassword) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.put("/user_password_updated", newPassword);
  }

  async forgotPassword(login) {
    const httpClient = new HTTPClientPublic();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/forgot_password`, login, headers);
  }

  async resetPassword(data) {
    const httpClient = new HTTPClientPublic();
    const api = await httpClient.configure();
    const headers = { headers: { "Content-Type": "application/json" } };
    return api.post(`/reset_password`, data, headers);
  }

  async updateInternalPassword(data) {
    const httpClient = new HTTPClient();
    const api = await httpClient.configure();
    return api.post("/update_password", data);
  }

  async fetchUserConfigs() {
    const httpClient = new HTTPClient()
    const api = await httpClient.configure()
    return api.get("/usercustom_params")
  }

  async changeUserConfigs(data) {
    const httpClient = new HTTPClient()
    const api = await httpClient.configure()
    return api.post("/usercustom_params", data)
  }
}

export default new UserService();
